import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import styled from 'foundations-theming/utils';
import { View } from 'foundations-components/components/View';
import { getIconComponentByName, isIconName } from '../../utils/getIconComponent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSpan = styled.span.withConfig({
  displayName: "OptionComponent__StyledSpan",
  componentId: "sc-1kuudgp-0"
})(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.space[200],
  paddingBottom: theme.space[200],
  paddingLeft: theme.space[200],
  paddingRight: theme.space[500]
}));
export const OptionComponent = props => {
  var _option$options;
  const {
      children,
      option
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if ((_option$options = option.options) !== null && _option$options !== void 0 && _option$options.length || option.isSpecial) {
    return children;
  } else {
    const IconComponent = isIconName(option.icon) ? getIconComponentByName(option.icon) : null;
    return /*#__PURE__*/_jsxs(StyledSpan, Object.assign({}, rest, {
      children: [IconComponent && /*#__PURE__*/_jsx(View, {
        paddingInlineEnd: "300"
        // The inherited line-height was causing the icon to be 27px tall,
        //   which increased the height of the option.
        ,
        blockSize: "24px",
        children: /*#__PURE__*/_jsx(IconComponent, {
          color: "icon-primary-disabled",
          size: "500"
        })
      }), /*#__PURE__*/_jsx(TruncateString, {
        useFlex: !!option.badge,
        fixedChildren: option.badge,
        children: option.text || option.value
      })]
    }));
  }
};